<template>
  <div :class="['control__action', { 'mb-15': !!selectStatus }]">
    <div class="additional">
      {{ normalizeIndex }}
    </div>
    <div class="control__choice">
      <div
        :class="['fakeoverlay', { disabled: !selectStatus }]"
        @click="selectStatus = !selectStatus"
      />
      <el-select
        v-model="selectValue"
        class="control__select"
        :disabled="!selectStatus"
        :placeholder="index === 1 ? `Choose` : `Everything else, alphabetically`"
        @change="changeOption"
      >
        <el-option
          v-for="(element, key) in options"
          :key="key"
          :label="element.label"
          :value="element.value"
        />
      </el-select>
    </div>
    <el-checkbox v-model="selectStatus" class="control__checkbox" @change="changeOption" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ordinalSuffixOf } from "@/utils/ordinal-suffix";

export default {
  name: "OrderItemInput",
  props: {
    select: {
      type: String,
      default: "",
    },
    status: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    options: {
      type: Array,
      default: Function,
    },
  },
  data() {
    return {
      selectValue: this.select,
      selectStatus: this.status,
    };
  },
  computed: {
    ...mapState(["settings"]),
    normalizeIndex() {
      return ordinalSuffixOf(this.index);
    },
  },
  emits: ["changeOption"],
  watch: {
    select(newValue) {
      this.selectValue = newValue;
    },
    status(newValue) {
      this.selectStatus = newValue;
      if (!newValue) {
        this.selectValue = '';
      }
    }
  },
  methods: {
    changeOption() {
      const value = this.selectStatus === true ? this.selectValue : undefined;
      this.$emit("changeOption", {
        index: this.index,
        value: value,
        status: this.selectStatus,
      });
    },
  },
};
</script>

<style scoped>
.additional {
  color: #6c7683;
  padding-left: 20px;
  width: 30px;
  flex-shrink: 0;
  text-align: right;
}
</style>
